import { render, staticRenderFns } from "./Detail-Property.vue?vue&type=template&id=1dba3d6a&scoped=true"
import script from "./Detail-Property.vue?vue&type=script&lang=js"
export * from "./Detail-Property.vue?vue&type=script&lang=js"
import style0 from "./Detail-Property.vue?vue&type=style&index=0&id=1dba3d6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dba3d6a",
  null
  
)

export default component.exports